module.exports = __webpack_public_path__ + "img/bold-cross.6b313982.svg";